import { Flex } from '@chakra-ui/react';
import VText from '@voly/ui-components/src/v2/VText.jsx';
import VTooltip from '@voly/ui-components/src/v2/VTooltip';
import { ReactElement } from 'react';
import { TCustomField } from 'src/app/project/modules/custom-fields/custom-fields.model';
import CustomFieldTypeIcon from './CustomFieldTypeIcon';

interface PointFieldNameProps {
  field: TCustomField;
}

const PointFieldName = ({ field }: PointFieldNameProps): ReactElement => (
  <Flex as="span" align="center" gap={1} minWidth="0">
    <CustomFieldTypeIcon field={field} size="md" />
    <VTooltip content={field.label} showOnlyWhenTruncated>
      <VText as="span" truncate>
        {field.label}
      </VText>
    </VTooltip>
  </Flex>
);

export default PointFieldName;
